import { colors } from 'ui/theme';
import { shapeNames } from 'ui/workflows/flowchart';
import { sendEmailDarkIcon, sendSMSDarkIcon, sendPushDarkIcon } from 'ui/workflows/flowchart/icons';
import { NODE_TYPES } from 'modules/workflows/constants';

export const childNodesStyle = {
  accentColorBackground: colors.cyan10,
  [shapeNames.divider]: { isFullWidth: false, height: 1, cursor: 'pointer' },
  [shapeNames.footerContentWrapper]: { padding: [4, 5, 15], cursor: 'pointer' },
  [shapeNames.icon]: { width: 24, height: 24, cursor: 'pointer' },
  [shapeNames.iconBackground]: { width: 34, height: 34, cursor: 'pointer' },
  [shapeNames.title]: { cursor: 'pointer' },
  [shapeNames.wrapper]: { stroke: colors.grey15, lineWidth: 1, radius: 4, cursor: 'pointer' },
};

export const ChildNodeIcon = {
  [NODE_TYPES.SEND_EMAIL]: sendEmailDarkIcon,
  [NODE_TYPES.SEND_SMS]: sendSMSDarkIcon,
  [NODE_TYPES.SEND_PUSH]: sendPushDarkIcon,
};
